import { PayStatement } from "@wingspanhq/wingspan-api-sdk";

/**
 * Worker name for a pay statement row.
 *
 * TODO(v3): the real name needs a Payee/Account join the flat pay-statement
 * read doesn't provide (`listPayStatements` has no `expand`), so this falls
 * back to the statement number / payee account id until a projection or bulk
 * name lookup exists.
 */
export const selectorPayStatementEmployeeName = (
  payStatement: PayStatement
): string =>
  payStatement.payStatementNumber ??
  payStatement.payeeAccountId ??
  "Unknown employee";
